import { BaseEnum } from "./baseEnum";

const listWorkforceplanTypeEnum: Array<WorkforceplanEventType> = [];

export class WorkforceplanEventType extends BaseEnum {
	static None = new WorkforceplanEventType(0, 'None', 'Não mapeado', 'light-primary');
	static OnLeave = new WorkforceplanEventType(1, 'OnLeave', 'Atestado', 'light-warning');
	static InVacation = new WorkforceplanEventType(2, 'InVacation', 'Férias', 'light-success');
	static InTraining = new WorkforceplanEventType(3, 'InTraining', 'Treinamento', 'light-primary');
	static InAptitude = new WorkforceplanEventType(4, 'InAptitude', 'Aptidão', 'light-info');
	static InResignation = new WorkforceplanEventType(5, 'InResignation', 'Desligamento', 'danger text-white');
	static InDayOff = new WorkforceplanEventType(6, 'InDayOff', 'Folga', 'light-danger');

	constructor(public id: number, public value: string, public label: string, public className: string) {
		super(id, value, label, className);

		listWorkforceplanTypeEnum.push(this);
	}

	public static buildListEnum(): Array<BaseEnum> {
		return listWorkforceplanTypeEnum;
	}
}
